import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { toast } from 'sonner';
import useBundleTranslation from 'i18n';
import styles from './Toast.styles';

export type ToastType = 'success' | 'error' | 'info';
interface ToastProps {
    id: string | number;
    type: ToastType;
    title?: string;
    description?: string;
    button?: {
        label: string;
        onClick: () => void;
    };
}

const iconsAlias = {
    success: 'success',
    error: 'alert',
    info: 'info-circle',
};

export default function Toast({ title, type, description, id }: ToastProps) {
    const { t } = useBundleTranslation();
    const handleCLose = () => {
        toast.dismiss(id);
    };

    return (
        <Stack className={`toast-item toast-item--type-${type}`} direction={'row'} sx={styles.toastItem}>
            <Box className={'toast-item__icon'} sx={styles.toastItemIcon}>
                <IconMi icon={iconsAlias[type] ?? 'info'} />
            </Box>
            <Box className={'toast-item__content'} sx={styles.toastItemContent}>
                <Box className={'toast-item__title'} sx={styles.toastItemTitle}>
                    {title ?? t(type)}
                </Box>
                <Box className={'toast-item_desc'} sx={styles.toastItemDesc}>
                    {description}
                </Box>
            </Box>
            <Box sx={styles.toastItemCloseBtn} onClick={handleCLose}>
                <IconMi icon="times" />
            </Box>
        </Stack>
    );
}
